import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const jupiterContainerConfig = {
transform(props) {
  const { ...rest } = props;
  return {
    display: "flex",
    alignItems: "center",
    maxW: "1450px",
    mx: "auto",
    ...rest
  };
},
defaultValues:{}}

export const getJupiterContainerStyle = (styles = {}) => {
  const _styles = getPatternStyles(jupiterContainerConfig, styles)
  return jupiterContainerConfig.transform(_styles, patternFns)
}

export const jupiterContainer = (styles) => css(getJupiterContainerStyle(styles))
jupiterContainer.raw = getJupiterContainerStyle